import { API_PART_URL } from "src/shared/config/src";
import { getAxiosInstance } from "../api";
import { CommunicationReplyPostData, CreateConversationRequestType, SendMessagePayload, SendMessagePostData } from "src/shared/types/src";

export const fetchCommunication = async (childInstanceUrl: string, eymanageNurseryId: string, page: number): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/communications`, { params: { page } }).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const fetchCommunicationMessage = async (childInstanceUrl: string, eymanageNurseryId: string, communiationId: number): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/communication/${communiationId}`).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const sendCommunicationMessage = async (childInstanceUrl: string, eymanageNurseryId: string, communiationId: number, postData: CommunicationReplyPostData): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.post(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/communication/${communiationId}/reply`, postData).then((res) => {
    const response = res.data;
    if (response && response.status === 'success') {
      return response.data;
    }
    return null;
  });
};

export const fetchConversationList = async (childInstanceUrl: string, eymanageNurseryId: string, page: number): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/list`, { params: { page } }).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const fetchInbox = async (childId: string, page: number): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`/child/${childId}/inbox`, { params: { page } }).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const fetchSentBox = async (childId: string, page: number): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`/child/${childId}/sent-messages`, { params: { page } }).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const fetchMessage = async (childId: string, messageId: string): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`/child/${childId}/messages/${messageId}`).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const sendMessage = async (childId: string, postData: SendMessagePostData): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.post(`/child/${childId}/send-message`, postData).then((res) => {
    const response = res.data;
    if (response && response.status === 'success') {
      return response.data;
    }
    return null;
  });
};

export const fetchConversationParticipants = async (childInstanceUrl: string, eymanageNurseryId: string): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/v2/participants-groups`).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const createConversation = async (childInstanceUrl: string, eymanageNurseryId: string, params: CreateConversationRequestType): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.post(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/create`, params).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const fetchConversationMessages = async (childInstanceUrl: string, eymanageNurseryId: string, conversationId: string, page: number): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/${conversationId}/messages?page=${page}`).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const pollConversationMessages = async (childInstanceUrl: string, eymanageNurseryId: string, conversationId: string, lastMessageId?: string): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/${conversationId}/poll-messages`, { params: { lastMessageId } }).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const sendConversationMessage = async (childInstanceUrl: string, eymanageNurseryId: string, conversationId: string, lastMessageId: string, postData: SendMessagePayload): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.post(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/${conversationId}/send-message`, postData, { params: { lastMessageId } }).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
}

export const uploadConversationMessageFile = async (childInstanceUrl: string, eymanageNurseryId: string, conversationId: string, lastMessageId: string, formData: any, uploadProgressCallback: any): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  const url = `${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/${conversationId}/send-attachment`;
  return retryAxios.post(url, formData, {
    params: { lastMessageId },
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: uploadProgressCallback,
  });
}

export const markReadConversationMessage = async (childInstanceUrl: string, eymanageNurseryId: string, conversationId: string, fromMessageId: string): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.patch(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/${conversationId}/mark-read`, { fromMessageId }).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
}

export const markUnreadConversationMessage = async (childInstanceUrl: string, eymanageNurseryId: string, conversationId: string, fromMessageId: string): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.patch(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/${conversationId}/mark-unread`, { fromMessageId }).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
}

export const deleteConversationMessage = async (childInstanceUrl: string, eymanageNurseryId: string, conversationId: string, messageId: string): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.delete(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/${conversationId}/message/${messageId}`).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
}

export const deleteEylogMessage = async (childId: string, messageId: string): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.delete(`/child/${childId}/messages/${messageId}`).then((res) => {
    console.log("response : ", JSON.stringify(res, null, 2));
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const getTotalUnreadConversationsCount = async (childInstanceUrl: string, eymanageNurseryId: string): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/unread-count`).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};

export const fetchConversationDetail = async (childInstanceUrl: string, eymanageNurseryId: string, conversationId: string): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`${childInstanceUrl}${API_PART_URL}/nursery/${eymanageNurseryId}/conversations/${conversationId}/participants`).then((res) => {
    const response = res.data;
    if (response && response.status === "success") {
      return response.data;
    }
    return null;
  });
};